// extracted by mini-css-extract-plugin
export default {"label":"ControlledQuantityStepper_label__yYwbl"};